import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import _get from 'lodash/get';
import AsicIntro from 'components/asic/AsicIntro';
import HashrateS9 from 'components/asic/hashrate/HashrateS9';
import HashrateS10 from 'components/asic/hashrate/HashrateS10';
import HashrateS17 from 'components/asic/hashrate/HashrateS17';
import HashrateT9 from 'components/asic/hashrate/HashrateT9';
import HashrateT17 from 'components/asic/hashrate/HashrateT17';
import HashrateL3 from 'components/asic/hashrate/HashrateL3';
import Efficiency from 'components/asic/Efficiency';
import Speed from 'components/asic/Speed';
import Overclock from 'components/asic/Overclock';
import Integration from 'components/asic/Integration';
import PartnersMsk from 'components/asic/PartnersMsk';
import AsicModels from 'components/asic/AsicModels';
import MODELS from 'constants/asicModels';
import WL, { WL_BIGMINER } from 'constants/whiteLabel';
import Transition from 'components/Transition';
import gs from 'pages/pages.module.css';
import s from './asicContainer.module.css';

class AsicContainer extends Component {
  render() {
    const { selected } = this.props;
    const key = (selected && selected.key) || _get(MODELS, 'S17');
    const devfee = (selected && selected.devfee) || _get(MODELS, 'S17.devfee');

    return (
      <div className={s.root}>
        <AsicIntro devfee={devfee} selected={key} />
        <Transition
          defaultStyle={{
            transition: `opacity 600ms ease-in-out`,
            opacity: '0',
          }}
          transitionTime={600}
        >
          <div className={s.asicWrapper}>
            <h2>ASICS</h2>
            <div className={s.fullWidth}>
              <AsicModels selectedAsic={key} />
              <div className={s.textWrapper}>
                <div className={cx(gs.backgroundHeader, s.backgroundTitle)}>awesome</div>
                <h2 className={cx(s.title, s.bold)}>
                <FormattedMessage
                  id="AsicIntro.caption2"
                  defaultMessage="Hive OS is {free} for Hiveon ASIC users"
                  values={{ free: <span className={s.orange}><FormattedMessage id="AsicIntro.free" defaultMessage="Free" /></span> }}
                />
                </h2>
                <div className={s.text}>
                  <div className={s.textItem}>
                    <FormattedMessage
                      id="AsicIntro.caption3"
                      defaultMessage="with only {devfee} in parallel mining"
                      values={{ devfee: <b>{devfee || '2%'} <FormattedMessage id="AsicIntro.devfee" defaultMessage="devfee" /></b> }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {key === _get(MODELS, 'S17.key') && <HashrateS17 />}
            {key === _get(MODELS, 'T17.key') && <HashrateT17 />}
            {key === _get(MODELS, 'S10.key') && <HashrateS10 />}
            {key === _get(MODELS, 'S9.key') && <HashrateS9 />}
            {key === _get(MODELS, 'T9.key') && <HashrateT9 />}
            {key === _get(MODELS, 'L3.key') && <HashrateL3 />}
            {[_get(MODELS, 'S9.key'), _get(MODELS, 'S10.key')].includes(key) && <Efficiency />}
            <Speed />
            <Overclock selected={key} />
            <Integration />
            {(WL.key !== WL_BIGMINER) && <PartnersMsk />}
          </div>
        </Transition>
      </div>
    );
  }
}


export default AsicContainer;
